import { useEffect } from 'react'

const APP_URL = 'https://app.myofade.com'
const HOME_TITLE = 'MyoFade - Muscle recovery heatmap for the gym'
const NAME_TITLE = 'The name - MyoFade'

export default function NamePage() {
  useEffect(() => {
    const previous = document.title
    document.title = NAME_TITLE
    return () => {
      document.title = previous || HOME_TITLE
    }
  }, [])

  return (
    <main id="main" className="name-page">
      <section className="name-hero" aria-labelledby="name-brand">
        <div className="name-hero-bg" aria-hidden="true" />
        <p className="name-kicker">Etymology</p>
        <h1 id="name-brand" className="name-wordmark" aria-label="MyoFade">
          <span className="name-chunk name-chunk-my" aria-hidden="true">
            My
          </span>
          <span className="name-chunk name-chunk-o" aria-hidden="true">
            <span className="name-o-ring" />
            <span className="name-o-letter">o</span>
          </span>
          <span className="name-chunk name-chunk-fade" aria-hidden="true">
            Fade
          </span>
        </h1>
        <p className="name-headline">Muscle + fade.</p>
        <p className="name-support">
          <em>Myo</em> is the Greek combining form for muscle. <em>Fade</em> is how recovery shows up
          on the map - ember when worked, cooling back to grey when ready.
        </p>
        <div className="cta-row">
          <a className="btn-primary" href={APP_URL}>
            Launch MyoFade
          </a>
          <a className="btn-ghost" href="/">
            Back home
          </a>
        </div>
      </section>

      <section className="section name-breakdown" aria-labelledby="breakdown-title">
        <h2 id="breakdown-title">How the word is built</h2>
        <p className="lead">
          Not three syllables inventing themselves - two roots, joined the way anatomy textbooks
          already join them.
        </p>

        <dl className="etym-list">
          <div className="etym-row etym-row-myo">
            <dt>
              <span className="etym-term">myo-</span>
              <span className="etym-from">from Greek <i>mys / myos</i></span>
            </dt>
            <dd>
              The standard medical prefix for muscle - same stem you hear in <i>myology</i> and{' '}
              <i>myopathy</i>. The trailing <strong>o</strong> is the combining vowel that lets the
              root attach cleanly to what follows. It is not a separate word.
            </dd>
          </div>
          <div className="etym-row etym-row-fade">
            <dt>
              <span className="etym-term">Fade</span>
              <span className="etym-from">the recovery map</span>
            </dt>
            <dd>
              Worked muscle lights up ember-red. As fatigue decays on a recovery curve, the color
              fades back toward steel grey - ready to train again.
            </dd>
          </div>
        </dl>

        <p className="name-close">
          So <strong>MyoFade</strong> is literally the product: a muscle map that fades with
          recovery, readable at a glance on the gym floor.
        </p>
      </section>
    </main>
  )
}
